import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow: `inset 0 0 0 1px ${theme.palette.grey[400]}, inset 0 -1px 0 ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.common.white,
    '$root.Mui-focusVisible &': {
      outline: `2px auto ${theme.palette.secondary.main}`,
      outlineOffset: 2,
    },
    'input:disabled ~ &': {
      boxShadow: `inset 0 0 0 1px ${theme.palette.grey[300]}, inset 0 -1px 0 ${theme.palette.grey[300]}`,
      // background: 'rgba(206,217,224,.5)',
    },
  },
  checkedIcon: {
    backgroundColor: theme.palette.common.white,
    '&:before': {
      display: 'block',
      width: 5,
      height: 9,
      position: 'relative',
      top: 2,
      left: 5,
      border: `solid ${theme.palette.secondary.main}`,
      borderWidth: '0 1px 1px 0',
      transform: 'rotate(45deg)',
      content: '""',
    },
  },
}));
